__webpack_require__.p = "https://ts-website-project-sample-fast.uat.sennder.com/";